import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

export interface WishlistItem {
  id: string;
  user_id: string;
  relationship_id: string;
  title: string;
  description: string | null;
  link: string | null;
  created_at: string;
  updated_at: string;
}

export interface OccasionItem {
  id: string;
  user_id: string;
  relationship_id: string;
  title: string;
  date: string;
  created_at: string;
  updated_at: string;
}

interface Relationship {
  id: string;
  creator_user_id: string;
  guest_user_id: string | null;
  invite_token: string;
  deleted_at: string | null;
  created_at: string;
}

export interface RelationshipResponse {
  relationship: Relationship;
  user_wishlist: WishlistItem[];
  partner_wishlist: WishlistItem[];
  user_occasions: OccasionItem[];
}

export function useRelationship(relationshipId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.relationship.byId(relationshipId ?? ''),
    queryFn: async () => {
      const response = await api
        .get(`relationships/${relationshipId}`)
        .json<RelationshipResponse>();
      return response;
    },
    enabled: !!relationshipId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
